import { createSlice } from '@reduxjs/toolkit';

const initialState = {};
export const workExperienceSlice = createSlice({
  name: 'workExperienceDetails',
  initialState,
  reducers: {
    resetWorkExperienceSlice: (state) => initialState,
    addWorkExperience: (state, action) => action.payload,
  },
});

// Action creators are generated for each case reducer function
export const { resetWorkExperienceSlice, addWorkExperience } = workExperienceSlice.actions;

export default workExperienceSlice.reducer;
